import { pathToFileUrl, resolveDirectoryUrl } from "./urlHelpers.js"

let jsenvBundlingDirectoryUrl
if (typeof __filename === "string") {
  jsenvBundlingDirectoryUrl = resolveDirectoryUrl(
    // get ride of dist/node/main.js
    "../../",
    pathToFileUrl(__filename),
  )
} else {
  jsenvBundlingDirectoryUrl = resolveDirectoryUrl(
    // get ride of src/jsenvBundlingDirectoryUrl.js
    "../",
    import.meta.url,
  )
}

export { jsenvBundlingDirectoryUrl }
